import { useState } from "react";
import { Modal } from "@/components/shared/data-display/modal/modal";
import styles from "./condition-ratings-modal.module.scss";

const ConditionRatingsModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={styles.trigger}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        More
      </button>
      <Modal
        open={open}
        onOpenChange={setOpen}
        isDismissible
        title="About Our Condition Ratings"
        primaryButtonText="Close"
        primaryButtonAction={() => setOpen(false)}
        containerClassName={styles.modal}
      >
        <ul className={styles.ratings}>
          <li>
            <strong>New:</strong> A brand-new, unused, unread copy in perfect
            condition.
          </li>
          <li>
            <strong>Like New:</strong> An apparently unread copy in excellent
            condition. The dust cover is intact, and the pages are clean and not
            marred by notes or folds of any kind.
          </li>
          <li>
            <strong>Very Good:</strong> A copy that has been read, but remains
            in excellent condition. May have writing on the inside cover but
            pages are unmarred.
          </li>
          <li>
            <strong>Good:</strong> A copy that has been read, but remains in
            clean condition. All pages and covers are intact. The spine may show
            signs of wear. Pages can include limited notes and highlighting, and
            the copy can include &quot;From the library of&quot; labels or
            previous owner inscriptions.
          </li>
          <li>
            <strong>Acceptable/Fair:</strong> A readable copy. All pages are
            intact, and the cover is intact although the dust cover may be
            missing. Pages may include considerable notes-in pen or
            highlighter-but the notes will not obscure the text.
          </li>
          <li>
            <strong>ThriftBooks Deal:</strong> Items with a deal tag are rated
            as being Acceptable or Good as defined above.
          </li>
          <li>
            When purchasing a used item, we cannot guarantee it will come with
            all original accompanying content such as toys, necklaces, CDs,
            access codes, or other bonus items. Cover art images are stock
            photos unless otherwise specified.
          </li>
        </ul>
      </Modal>
    </>
  );
};

export default ConditionRatingsModal;
